export default __webpack_public_path__ + "static/media/bg-4.056fe0d4.jpg";